import React from 'react'
import { Button, spacer, Popover, ThumbIcon, color } from 'stylist'
import SubmitClipFeedbackMutation from 'mutations/SubmitClipFeedback'
import ClipFeedbackTextDialog from './ClipFeedbackTextDialog'
import styled from 'react-emotion'

const ClipFeedbackContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacer(2)};
`

const ThumbUp = styled(ThumbIcon)`
  color: ${({ dark, selected }) =>
    selected ? color('lightBrandGreen') : dark ? color('white') : color('ink')};
  fill: ${({ dark }) => (dark ? color('ink') : color('white'))};
`

const ThumbDown = styled(ThumbIcon)`
  margin-top: 1px;
  color: ${({ dark, selected }) =>
    dark ? (selected ? color('pewter') : color('white')) : color('ink')};
  fill: ${({ dark, selected }) =>
    selected ? (dark ? color('ink') : color('silver')) : null};
`

const ThumbButton = styled(Button)`
  padding-left: ${spacer(2)};
  padding-right: ${spacer(2)};

  ${ThumbUp}, ${ThumbDown} {
    width: 1rem;
    height: 1rem;
  }
`

const ClipFeedback = ({ clip: { feedback, id: clipId }, dark }) => (
  <SubmitClipFeedbackMutation clipId={clipId}>
    {submitClipFeedback => (
      <Popover
        render={props => <ClipFeedbackTextDialog clipId={clipId} {...props} />}
        placement="left"
      >
        {({ ref, show }) => (
          <ClipFeedbackContainer>
            <ThumbButton
              size="sm"
              kind="ghost"
              onClick={e => {
                e.stopPropagation()
                submitClipFeedback(true)
              }}
              disabled={feedback && feedback.positive}
            >
              <ThumbUp
                dark={dark}
                direction="up"
                selected={feedback && feedback.positive}
              />
            </ThumbButton>
            <ThumbButton
              size="sm"
              kind="ghost"
              onClick={e => {
                e.stopPropagation()
                submitClipFeedback(false)
                show()
              }}
              innerRef={ref}
              disabled={feedback && !feedback.positive}
            >
              <ThumbDown
                dark={dark}
                direction="down"
                selected={feedback && !feedback.positive}
              />
            </ThumbButton>
          </ClipFeedbackContainer>
        )}
      </Popover>
    )}
  </SubmitClipFeedbackMutation>
)

export default ClipFeedback



// WEBPACK FOOTER //
// ./src/routes/video/components/ClipFeedback.js